package ir.yusefpasha.components

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.navigation.OpenLinkStrategy
import com.varabyte.kobweb.silk.components.icons.fa.*
import com.varabyte.kobweb.silk.components.navigation.Link
import com.varabyte.kobweb.silk.components.style.toModifier
import ir.yusefpasha.style.SocialLinkStyle
import ir.yusefpasha.util.Res
import org.jetbrains.compose.web.css.px

@Composable
fun SocialBar(isRow: Boolean = false) {
    if (isRow){
        Row(
            modifier = Modifier
                .margin(top = 25.px)
                .padding(leftRight = 25.px)
                .minHeight(40.px)
                .borderRadius(r = 20.px)
                .backgroundColor(Colors.White),
            verticalAlignment = Alignment.CenterVertically,
            horizontalArrangement = Arrangement.Center
        ) {
            SocialLinks(isRow)
        }
    }else {
        Column(
            modifier = Modifier
                .margin(right = 25.px)
                .padding(topBottom = 25.px)
                .minWidth(40.px)
                .borderRadius(r = 20.px)
                .backgroundColor(Colors.White),
            verticalArrangement = Arrangement.Center,
            horizontalAlignment = Alignment.CenterHorizontally
        ) {
            SocialLinks(isRow)
        }
    }
}

@Composable
private fun SocialLinks(isRow: Boolean) {
    Link(
        path = Res.Links.GITHUB,
        openExternalLinksStrategy = OpenLinkStrategy.IN_NEW_TAB
    ) {
        FaGithub(
            modifier = SocialLinkStyle.toModifier()
                .margin(
                    bottom = if (isRow) 0.px else 40.px,
                    right = if (isRow) 40.px else 0.px
                ),
            size = IconSize.XL
        )
    }
    Link(
        path = Res.Links.TWITTER,
        openExternalLinksStrategy = OpenLinkStrategy.IN_NEW_TAB
    ) {
        FaTwitter(
            modifier = SocialLinkStyle.toModifier()
                .margin(
                    bottom = if (isRow) 0.px else 40.px,
                    right = if (isRow) 40.px else 0.px
                ),
            size = IconSize.XL
        )
    }
    Link(
        path = Res.Links.TELEGRAM,
        openExternalLinksStrategy = OpenLinkStrategy.IN_NEW_TAB
    ) {
        FaTelegram(
            modifier = SocialLinkStyle.toModifier()
                .margin(
                    bottom = if (isRow) 0.px else 40.px,
                    right = if (isRow) 40.px else 0.px
                ),
            size = IconSize.XL
        )
    }
    Link(
        path = Res.Links.INSTAGRAM,
        openExternalLinksStrategy = OpenLinkStrategy.IN_NEW_TAB
    ) {
        FaInstagram(
            modifier = SocialLinkStyle.toModifier(),
            size = IconSize.XL
        )
    }
}